<wj-tab-panel class="full-size" selected-index="1" [isAnimated]="true">
    @for (category of categories(); track category) {
        <wj-tab>
            <a>{{category}}</a>

            <div style="padding: 10px">
                @for (matrix of matrices(category); track matrix.id) {
                    <div style="padding: 5px">
                        <app-app-config-matrix [matrix]="matrix" [values]="configMatrixValues[matrix.key]" [refDataSvc]="pfData">
                        </app-app-config-matrix>
                    </div>
                }
            </div>

        </wj-tab>
    }
</wj-tab-panel>
